// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { OutcomeModalCategoryInformationFragmentDoc } from '../../review/modals/__generated-gql-types__/OutcomeModal.generated';
import { CoachAvailabilityInfoCoachFragmentDoc } from './CoachAvailabilityInfo.generated';
import { IntroVideoCoachFragmentDoc } from './IntroVideo.generated';
import { MessageModalCoachFragmentDoc } from '../modals/MessageModal/__generated-gql-types__/index.generated';
import {
  ScheduleModalCoachFragmentDoc,
  ScheduleModalCoachingSessionFragmentDoc,
} from '../modals/__generated-gql-types__/ScheduleModal.generated';
import { SchedulingSuccessModalCoachFragmentDoc } from '../modals/ScheduleModal/__generated-gql-types__/SchedulingSuccessModal.generated';
import {
  LeaveAReviewModalCoachFragmentDoc,
  LeaveAReviewModalReviewFragmentDoc,
} from '../../review/modals/__generated-gql-types__/LeaveAReviewModal.generated';
import { UpcomingSessionsCtaCoachFragmentDoc } from './UpcomingSessionsCTA.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachMessageCtaCoachFragment = {
  __typename?: 'Coach';
  id: string;
  couldScheduleIntro?: boolean | null;
  visibility: Types.CoachVisibility;
  hourlyRate?: number | null;
  averageFirstResponseLatency?: number | null;
  slug: string;
  tier: Types.SkuTier;
  averageReviewRate: number;
  reviewTotal: number;
  everHadCoachingSessionWithCoach?: boolean | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    review?: { __typename?: 'Review'; id: string } | null;
    upcomingEnrolledSessions?: Array<{
      __typename?: 'CoachingSession';
      id: string;
      canceled: boolean;
      summary?: string | null;
      hasRecording: boolean;
      additionalTimeToBuy: number;
      durationInMinute: number;
      startAt: number;
      endAt: number;
      content:
        | {
            __typename: 'BootcampSession';
            bootcamp: { __typename?: 'Bootcamp'; id: string; title: string };
          }
        | {
            __typename: 'Class';
            id: string;
            name?: string | null;
            slug?: string | null;
            isFreeEvent?: boolean | null;
          }
        | {
            __typename: 'OneOnOneSession';
            title: string;
            order?: { __typename?: 'Order'; status: Types.OrderStatus } | null;
            introOrder?: {
              __typename?: 'Order';
              introCall?: {
                __typename?: 'IntroCall';
                packages?: Array<{
                  __typename?: 'OfferingPackage';
                  id: string;
                }> | null;
              } | null;
            } | null;
          };
      coach: {
        __typename?: 'Coach';
        id: string;
        user: { __typename?: 'User'; id: string; firstName: string };
      };
      attendees?: Array<{
        __typename?: 'Applicant';
        id: string;
        user: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          pictureLink?: string | null;
        };
      }> | null;
      recurringSession?: {
        __typename?: 'RecurringSession';
        id: string;
        formattedCadence: string;
        cadence: {
          __typename?: 'RecurringCadence';
          type: Types.RecurrenceType;
          dayOfWeek?: Types.DayOfWeek | null;
          weekOfMonth?: number | null;
          interval?: number | null;
          isLastWeekOfMonth?: boolean | null;
          startHour: number;
          startMinute: number;
          durationMinutes: number;
        };
      } | null;
    }> | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  matchedCoach?: {
    __typename?: 'MatchedCoach';
    id: string;
    status: Types.MatchedCoachStatus;
  } | null;
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    category: {
      __typename?: 'Category';
      id: string;
      name: string;
      goal: Types.GoalName;
      subCategoryTitle?: string | null;
      slug: string;
      subCategoryList?: Array<{
        __typename?: 'SubCategory';
        id: string;
        name: string;
      }> | null;
    };
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
    detail?: string | null;
    defaultAvailability?: {
      __typename?: 'DefaultAvailability';
      totalInMinute: number;
    } | null;
  } | null;
  introVideo?: {
    __typename?: 'VideoLink';
    duration: string;
    thumbnailLink: string;
    youtubeId: string;
  } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
};

export type CoachMessageCtaUserFragment = {
  __typename?: 'User';
  id: string;
  applicant?: {
    __typename?: 'Applicant';
    id: string;
    hasUnassignedTrialOrder?: boolean | null;
  } | null;
};

export type CoachMessageCtaGetUserQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CoachMessageCtaGetUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      hasUnassignedTrialOrder?: boolean | null;
    } | null;
  } | null;
};

export type CoachMessageCtaGetCoachByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['CoachUrn']['input'];
  categorySlugOrUrn?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type CoachMessageCtaGetCoachByIdQuery = {
  __typename?: 'Query';
  coach?: {
    __typename?: 'Coach';
    id: string;
    couldScheduleIntro?: boolean | null;
    visibility: Types.CoachVisibility;
    hourlyRate?: number | null;
    averageFirstResponseLatency?: number | null;
    slug: string;
    tier: Types.SkuTier;
    averageReviewRate: number;
    reviewTotal: number;
    everHadCoachingSessionWithCoach?: boolean | null;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    mostRecentOrder?: { __typename?: 'Order'; id: string } | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      paidTimeInMinute?: number | null;
      review?: { __typename?: 'Review'; id: string } | null;
      upcomingEnrolledSessions?: Array<{
        __typename?: 'CoachingSession';
        id: string;
        canceled: boolean;
        summary?: string | null;
        hasRecording: boolean;
        additionalTimeToBuy: number;
        durationInMinute: number;
        startAt: number;
        endAt: number;
        content:
          | {
              __typename: 'BootcampSession';
              bootcamp: { __typename?: 'Bootcamp'; id: string; title: string };
            }
          | {
              __typename: 'Class';
              id: string;
              name?: string | null;
              slug?: string | null;
              isFreeEvent?: boolean | null;
            }
          | {
              __typename: 'OneOnOneSession';
              title: string;
              order?: {
                __typename?: 'Order';
                status: Types.OrderStatus;
              } | null;
              introOrder?: {
                __typename?: 'Order';
                introCall?: {
                  __typename?: 'IntroCall';
                  packages?: Array<{
                    __typename?: 'OfferingPackage';
                    id: string;
                  }> | null;
                } | null;
              } | null;
            };
        coach: {
          __typename?: 'Coach';
          id: string;
          user: { __typename?: 'User'; id: string; firstName: string };
        };
        attendees?: Array<{
          __typename?: 'Applicant';
          id: string;
          user: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            pictureLink?: string | null;
          };
        }> | null;
        recurringSession?: {
          __typename?: 'RecurringSession';
          id: string;
          formattedCadence: string;
          cadence: {
            __typename?: 'RecurringCadence';
            type: Types.RecurrenceType;
            dayOfWeek?: Types.DayOfWeek | null;
            weekOfMonth?: number | null;
            interval?: number | null;
            isLastWeekOfMonth?: boolean | null;
            startHour: number;
            startMinute: number;
            durationMinutes: number;
          };
        } | null;
      }> | null;
      customerSubscription?: {
        __typename?: 'CustomerSubscription';
        id: string;
        sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      } | null;
    } | null;
    matchedCoach?: {
      __typename?: 'MatchedCoach';
      id: string;
      status: Types.MatchedCoachStatus;
    } | null;
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      id: string;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        goal: Types.GoalName;
        subCategoryTitle?: string | null;
        slug: string;
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          id: string;
          name: string;
        }> | null;
      };
    }> | null;
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
      detail?: string | null;
      defaultAvailability?: {
        __typename?: 'DefaultAvailability';
        totalInMinute: number;
      } | null;
    } | null;
    introVideo?: {
      __typename?: 'VideoLink';
      duration: string;
      thumbnailLink: string;
      youtubeId: string;
    } | null;
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      availableTime: number;
      hasUnlimitedPackage: boolean;
      cycles?: Array<{
        __typename?: 'SubscriptionCycle';
        timeInMinute: number;
        start?: number | null;
        end?: number | null;
      }> | null;
    } | null;
  } | null;
};

export type CoachMessageCtaLinkedInSelfServeRequestMutationVariables =
  Types.Exact<{
    input: Types.MatchedCoachInput;
  }>;

export type CoachMessageCtaLinkedInSelfServeRequestMutation = {
  __typename?: 'Mutation';
  createOpportunity: {
    __typename?: 'MatchedCoach';
    id: string;
    status: Types.MatchedCoachStatus;
    coach?: {
      __typename?: 'Coach';
      id: string;
      matchedCoach?: {
        __typename?: 'MatchedCoach';
        id: string;
        status: Types.MatchedCoachStatus;
      } | null;
    } | null;
  };
};

export const CoachMessageCtaCoachFragmentDoc = gql`
  fragment CoachMessageCTA_Coach on Coach {
    id
    couldScheduleIntro
    visibility
    hourlyRate
    user {
      id
      firstName
    }
    mostRecentOrder {
      id
    }
    coachingRelationship {
      id
      review {
        id
      }
    }
    matchedCoach {
      id
      status
    }
    categoryInformationList(showHidden: false) {
      ...OutcomeModal_CategoryInformation
    }
    availability {
      defaultAvailability {
        totalInMinute
      }
    }
    averageFirstResponseLatency
    ...CoachAvailabilityInfo_Coach
    ...IntroVideo_Coach
    ...MessageModal_Coach
    ...ScheduleModal_Coach
    ...SchedulingSuccessModal_Coach
    ...LeaveAReviewModal_Coach
    ...UpcomingSessionsCTA_Coach
  }
  ${OutcomeModalCategoryInformationFragmentDoc}
  ${CoachAvailabilityInfoCoachFragmentDoc}
  ${IntroVideoCoachFragmentDoc}
  ${MessageModalCoachFragmentDoc}
  ${ScheduleModalCoachFragmentDoc}
  ${SchedulingSuccessModalCoachFragmentDoc}
  ${LeaveAReviewModalCoachFragmentDoc}
  ${UpcomingSessionsCtaCoachFragmentDoc}
`;
export const CoachMessageCtaUserFragmentDoc = gql`
  fragment CoachMessageCTA_User on User {
    id
    applicant {
      id
      hasUnassignedTrialOrder
    }
  }
`;
export const CoachMessageCtaGetUserDocument = gql`
  query CoachMessageCTA_GetUser {
    user {
      ...CoachMessageCTA_User
    }
  }
  ${CoachMessageCtaUserFragmentDoc}
`;

/**
 * __useCoachMessageCtaGetUserQuery__
 *
 * To run a query within a React component, call `useCoachMessageCtaGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachMessageCtaGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachMessageCtaGetUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachMessageCtaGetUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachMessageCtaGetUserQuery,
    CoachMessageCtaGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachMessageCtaGetUserQuery,
    CoachMessageCtaGetUserQueryVariables
  >(CoachMessageCtaGetUserDocument, options);
}
export function useCoachMessageCtaGetUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachMessageCtaGetUserQuery,
    CoachMessageCtaGetUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachMessageCtaGetUserQuery,
    CoachMessageCtaGetUserQueryVariables
  >(CoachMessageCtaGetUserDocument, options);
}
export function useCoachMessageCtaGetUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachMessageCtaGetUserQuery,
        CoachMessageCtaGetUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachMessageCtaGetUserQuery,
    CoachMessageCtaGetUserQueryVariables
  >(CoachMessageCtaGetUserDocument, options);
}
export type CoachMessageCtaGetUserQueryHookResult = ReturnType<
  typeof useCoachMessageCtaGetUserQuery
>;
export type CoachMessageCtaGetUserLazyQueryHookResult = ReturnType<
  typeof useCoachMessageCtaGetUserLazyQuery
>;
export type CoachMessageCtaGetUserSuspenseQueryHookResult = ReturnType<
  typeof useCoachMessageCtaGetUserSuspenseQuery
>;
export type CoachMessageCtaGetUserQueryResult = Apollo.QueryResult<
  CoachMessageCtaGetUserQuery,
  CoachMessageCtaGetUserQueryVariables
>;
export const CoachMessageCtaGetCoachByIdDocument = gql`
  query CoachMessageCTA_GetCoachById(
    $id: CoachUrn!
    $categorySlugOrUrn: String
  ) {
    coach(id: $id) {
      ...CoachMessageCTA_Coach
    }
  }
  ${CoachMessageCtaCoachFragmentDoc}
`;

/**
 * __useCoachMessageCtaGetCoachByIdQuery__
 *
 * To run a query within a React component, call `useCoachMessageCtaGetCoachByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachMessageCtaGetCoachByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachMessageCtaGetCoachByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      categorySlugOrUrn: // value for 'categorySlugOrUrn'
 *   },
 * });
 */
export function useCoachMessageCtaGetCoachByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachMessageCtaGetCoachByIdQuery,
    CoachMessageCtaGetCoachByIdQueryVariables
  > &
    (
      | { variables: CoachMessageCtaGetCoachByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachMessageCtaGetCoachByIdQuery,
    CoachMessageCtaGetCoachByIdQueryVariables
  >(CoachMessageCtaGetCoachByIdDocument, options);
}
export function useCoachMessageCtaGetCoachByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachMessageCtaGetCoachByIdQuery,
    CoachMessageCtaGetCoachByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachMessageCtaGetCoachByIdQuery,
    CoachMessageCtaGetCoachByIdQueryVariables
  >(CoachMessageCtaGetCoachByIdDocument, options);
}
export function useCoachMessageCtaGetCoachByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachMessageCtaGetCoachByIdQuery,
        CoachMessageCtaGetCoachByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachMessageCtaGetCoachByIdQuery,
    CoachMessageCtaGetCoachByIdQueryVariables
  >(CoachMessageCtaGetCoachByIdDocument, options);
}
export type CoachMessageCtaGetCoachByIdQueryHookResult = ReturnType<
  typeof useCoachMessageCtaGetCoachByIdQuery
>;
export type CoachMessageCtaGetCoachByIdLazyQueryHookResult = ReturnType<
  typeof useCoachMessageCtaGetCoachByIdLazyQuery
>;
export type CoachMessageCtaGetCoachByIdSuspenseQueryHookResult = ReturnType<
  typeof useCoachMessageCtaGetCoachByIdSuspenseQuery
>;
export type CoachMessageCtaGetCoachByIdQueryResult = Apollo.QueryResult<
  CoachMessageCtaGetCoachByIdQuery,
  CoachMessageCtaGetCoachByIdQueryVariables
>;
export const CoachMessageCtaLinkedInSelfServeRequestDocument = gql`
  mutation CoachMessageCTA_LinkedInSelfServeRequest(
    $input: MatchedCoachInput!
  ) {
    createOpportunity(input: $input) {
      id
      status
      coach {
        id
        matchedCoach {
          id
          status
        }
      }
    }
  }
`;
export type CoachMessageCtaLinkedInSelfServeRequestMutationFn =
  Apollo.MutationFunction<
    CoachMessageCtaLinkedInSelfServeRequestMutation,
    CoachMessageCtaLinkedInSelfServeRequestMutationVariables
  >;

/**
 * __useCoachMessageCtaLinkedInSelfServeRequestMutation__
 *
 * To run a mutation, you first call `useCoachMessageCtaLinkedInSelfServeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachMessageCtaLinkedInSelfServeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachMessageCtaLinkedInSelfServeRequestMutation, { data, loading, error }] = useCoachMessageCtaLinkedInSelfServeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachMessageCtaLinkedInSelfServeRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CoachMessageCtaLinkedInSelfServeRequestMutation,
    CoachMessageCtaLinkedInSelfServeRequestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CoachMessageCtaLinkedInSelfServeRequestMutation,
    CoachMessageCtaLinkedInSelfServeRequestMutationVariables
  >(CoachMessageCtaLinkedInSelfServeRequestDocument, options);
}
export type CoachMessageCtaLinkedInSelfServeRequestMutationHookResult =
  ReturnType<typeof useCoachMessageCtaLinkedInSelfServeRequestMutation>;
export type CoachMessageCtaLinkedInSelfServeRequestMutationResult =
  Apollo.MutationResult<CoachMessageCtaLinkedInSelfServeRequestMutation>;
export type CoachMessageCtaLinkedInSelfServeRequestMutationOptions =
  Apollo.BaseMutationOptions<
    CoachMessageCtaLinkedInSelfServeRequestMutation,
    CoachMessageCtaLinkedInSelfServeRequestMutationVariables
  >;
